import { Injectable, Injector } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';
import { logout, updateAccountInfo } from './account.actions';
import { AuthService } from '../../common/services/auth.service';
import { getIntegrateIOFlag, getSSOFlag, redirectToIntegrateIOLogin } from '../helpers/account.helpers';
import { Lazy } from '../../lazy';

@Injectable({
  providedIn: 'root',
})
export class AccountEffects {
  @Effect({ dispatch: false })
  loadPermissions$ = this.actions$.pipe(
    ofType(updateAccountInfo),
    mergeMap(({ account }) => {
      if (account.permissions) {
        this.permissionsService.loadPermissions(account.permissions);
      }
      return EMPTY;
    }),
  );

  @Effect({ dispatch: false })
  logout$ = this.actions$.pipe(
    ofType(logout),
    tap(() => {
      this.authService.logout().subscribe(() => {
        if (getSSOFlag() || !getIntegrateIOFlag()) {
          this.$rootScope.stateGo('app.auth.signin');
        } else {
          redirectToIntegrateIOLogin();
        }
      });
    }),
  );

  private _$rootScope = new Lazy<any>(() => this.injector.get('$rootScope'));

  constructor(
    private actions$: Actions,
    private permissionsService: NgxPermissionsService,
    private readonly injector: Injector,
    private authService: AuthService,
  ) {}

  private get $rootScope() {
    // eslint-disable-next-line no-underscore-dangle
    return this._$rootScope.value;
  }
}
